import { LayoutEnum } from '@goldcast/api/content';

export const isLayoutAudiogram = (layout: LayoutEnum) => {
  return layout === 'AUDIOGRAM';
};

export const isLayoutDefault = (layout: LayoutEnum) => {
  return layout === 'DEFAULT';
};

export const isLayoutGrid = (layout: LayoutEnum) => {
  return layout === 'GRID';
};

export const isLayoutPip = (layout: LayoutEnum) => {
  return layout === 'PIP';
};

export const isLayoutActiveSpeaker = (layout: LayoutEnum) => {
  return layout === 'SPEAKER';
};

export const isLayoutFocus = (layout: LayoutEnum) => {
  return layout === 'FOCUS';
};

export const isSpeakerLayout = (layout: LayoutEnum) => {
  return !isLayoutAudiogram(layout) && !isLayoutDefault(layout);
};
